var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.494 2.2063C12.8103 2.76559 12.3557 3.55647 12.2165 4.4288C12.1592 4.69791 12.0393 4.94972 11.8665 5.1638C11.701 5.38623 11.4851 5.56617 11.2365 5.6888L9.854 6.3538C8.74459 6.89669 7.76103 7.66566 6.9665 8.6113C4.5165 11.5338 4.5165 12.8463 4.5165 17.8338C4.5165 20.0913 2.119 22.1388 1.489 24.1688C1.104 25.3763 0.894 28.1063 4.079 28.1063H27.844C28.3096 28.1288 28.7734 28.0324 29.1915 27.8263C29.6088 27.6185 29.9692 27.3122 30.2415 26.9338C30.5005 26.5523 30.6615 26.113 30.714 25.6563C30.7543 25.1894 30.6761 24.7199 30.4865 24.2913C29.8565 22.3838 27.354 20.1088 27.354 17.8513V14.1238",
    stroke: "#CE1111",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.649 28.1062C21.6543 28.8535 21.5178 29.5955 21.2465 30.2937C20.9551 30.986 20.5332 31.6157 20.004 32.1487C19.4711 32.6846 18.8349 33.1068 18.134 33.3895C17.4331 33.6723 16.6821 33.8098 15.9265 33.7937C15.1695 33.7984 14.4194 33.6496 13.7215 33.3562C12.3212 32.7722 11.208 31.659 10.624 30.2587C10.3495 29.5747 10.2127 28.8432 10.2215 28.1062",
    stroke: "#CE1111",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.649 10.9563C24.0652 10.9563 26.024 8.99755 26.024 6.5813C26.024 4.16505 24.0652 2.2063 21.649 2.2063C19.2328 2.2063 17.274 4.16505 17.274 6.5813C17.274 8.99755 19.2328 10.9563 21.649 10.9563Z",
    stroke: "#CE1111",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendency);
export default __webpack_public_path__ + "static/media/pendency.db69d77c16fc8e3ebf619482f6d7dbc1.svg";
export { ForwardRef as ReactComponent };